import { SvgIcon, SvgIconProps } from '@mui/material';

function DurationSVG(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M11.9996 3.45557C6.81508 3.45557 2.5918 7.68005 2.5918 12.8643C2.5918 18.0478 6.81532 22.272 11.9996 22.272C17.1838 22.272 21.4073 18.0476 21.4073 12.8643C21.4073 7.67981 17.1838 3.45557 11.9996 3.45557ZM11.9996 4.41557C16.6796 4.41557 20.4473 8.18429 20.4473 12.8643C20.4473 17.5198 16.6796 21.312 11.9996 21.312C7.31956 21.312 3.5518 17.5198 3.5518 12.8643C3.5518 8.18429 7.31956 4.41557 11.9996 4.41557Z"
        fill="#0173C8"
      />
      <path d="M11.5195 2.7356V3.9356H12.4795V2.7356H11.5195Z" fill="#0173C8" />
      <path
        d="M10.2242 1.75216C10.0077 1.72778 9.79202 1.84778 9.69547 2.03996C9.57547 2.23215 9.57547 2.44777 9.69547 2.63996C9.79203 2.83215 10.0077 2.95216 10.2242 2.95216H13.7755C13.9921 2.95216 14.2077 2.83216 14.3042 2.63996C14.4242 2.44778 14.4242 2.23216 14.3042 2.03996C14.2077 1.84778 13.992 1.72777 13.7755 1.75216H10.2242Z"
        fill="#0173C8"
      />
      <path
        d="M19.127 4.9922C18.9348 4.9922 18.767 5.08782 18.6235 5.20782L18.1913 5.66437C17.9991 5.83219 17.927 6.09563 17.9991 6.35999C18.047 6.59999 18.2635 6.81561 18.5035 6.86437C18.767 6.93563 19.0313 6.86437 19.1991 6.67219L19.6548 6.24C19.8713 6.02437 19.9191 5.71219 19.8235 5.42438C19.7035 5.16 19.4148 4.9922 19.127 4.9922Z"
        fill="#0173C8"
      />
      <path
        d="M11.9995 12.3599C11.8551 12.3842 11.7351 12.4321 11.6639 12.5277C11.5673 12.5999 11.5195 12.7199 11.5195 12.8642V17.3278C11.5195 17.4956 11.6152 17.6643 11.7595 17.7356C11.9039 17.8321 12.0951 17.8321 12.2395 17.7356C12.3839 17.6643 12.4795 17.4956 12.4795 17.3278V12.8642C12.4795 12.7199 12.4317 12.5999 12.3352 12.5042C12.2395 12.4321 12.1195 12.3599 11.9995 12.3599Z"
        fill="#0173C8"
      />
      <path
        d="M15.1198 9.19215C14.9998 9.19215 14.8798 9.23996 14.7841 9.33559L11.6641 12.5278C11.5441 12.6478 11.4954 12.8156 11.5198 12.9844C11.5676 13.1522 11.712 13.2956 11.8798 13.32C12.0476 13.3678 12.2154 13.32 12.3354 13.2L15.4799 10.0078C15.5999 9.86432 15.6477 9.67214 15.5755 9.47995C15.5042 9.28776 15.3119 9.19215 15.1198 9.19215Z"
        fill="#0173C8"
      />
    </SvgIcon>
  );
}

export default DurationSVG;
